import {useEffect, useState} from 'react';
import {useIntl} from 'react-intl';
import CardItem from 'Components/ProgramFinder/CardItem/ies';
import {getFavoritePrograms} from 'Callbacks/flagFavorites';

const CardList = ({list = []}) => {
  const intl = useIntl();
  // eslint-disable-next-line no-undef
  const userLoggedIn = drupalSettings.user.uid !== 0;
  const [favorites, setFavorites] = useState(userLoggedIn ? null : []);

  useEffect(() => {
    if (userLoggedIn) {
      getFavoritePrograms(intl).then((res) => {
        setFavorites(res);
      });
    }
  }, []);

  if (!list.length) {
    return '';
  }

  return (
    <div className="program-finder__items-wrapper grid gap-30 md:grid-cols-2 xl:grid-cols-3">
      {
        list && list.map((item) => {
          return <CardItem data={item}
                           key={`${item.nid}`}
                           isFavorite={favorites && favorites.includes(item.nid.toString())}
                           setFavorites={setFavorites}
                           userLoggedIn={userLoggedIn}/>
        })
      }
    </div>
  );
};

export default CardList;
